import {AOperation} from "./AOperation";
import {EOperationType} from "../utils/EOperationType";
import {Icon} from "../Icon";
import GPSCoordinates from "../GPSCoordinates";
import MarkerIconService from "../../services/map/MarkerIconService";
import {CSS_CLASS_NAME_GRAY_MARKER, CSS_CLASS_NAME_ORANGE_MARKER} from "../../services/UtilsService";
import ModelsRegExp from "../../services/ModelsRegExp";

class UninstallEquipment extends AOperation {

    private _equipmentId: string | undefined;

    constructor(id: string, idUser: string, date: Date, equipmentId?: string, geolocation?: GPSCoordinates, isSynchro?: boolean, commentary?: string) {
        const icon = new Icon(
            MarkerIconService.OPERATION_UNINSTALL_EQUIPMENT_ICON_PATH,
            MarkerIconService.generateIcon(MarkerIconService.OPERATION_UNINSTALL_EQUIPMENT_ICON_PATH, isSynchro ? CSS_CLASS_NAME_ORANGE_MARKER : CSS_CLASS_NAME_GRAY_MARKER)
        );
        super(id, idUser, EOperationType.UninstallationEquipment, date, icon, geolocation, isSynchro, commentary);
        this._equipmentId = equipmentId;
    }

    get equipmentId(): string | undefined {
        return this._equipmentId;
    }

    set equipmentId(value: string | undefined) {
        this._equipmentId = value;
    }

    public static remapObjectToOperation(object: any): UninstallEquipment | null {
        let operation: UninstallEquipment | null = null;
        if(
            object._id &&
            object._idUser &&
            object._date &&
            object._geolocation &&
            object._equipmentId
        ) {
            const location = GPSCoordinates.remapObjectToGPSCoordinate(object._geolocation);
            if(location) {
                operation = new UninstallEquipment(
                    object._id,
                    object._idUser,
                    object._date,
                    object._equipmentId,
                    location,
                    object._isSynchro,
                    object._commentary
                );
            }
        }
        return operation;
    }

    private isEquipmentIdCorrect(): boolean {
        let isCorrect = false;
        if(this.equipmentId !== undefined) {
            const match = ModelsRegExp.elementUnknown.exec(this.equipmentId);
            if(match) {
                isCorrect = true;
            }
        }
        return isCorrect;
    }

    isCorrect(): boolean {
        return (
            super.isCorrect() &&
            this.isEquipmentIdCorrect()
        );
    }
}

export default UninstallEquipment;
